"use strict";
exports.__esModule = true;
exports.PinOverlayComponent = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var map_1 = require("../googlemap/map");
var PinOverlayComponent = function (props) {
    var pinOverlayRef = React.useRef(null);
    var _a = React.useState(false), created = _a[0], setCreated = _a[1];
    React.useEffect(function () {
        map_1.createMarker(props.markerStore, props.map, props.pin).then(function (pinOverlay) {
            pinOverlayRef.current = pinOverlay;
            setCreated(true);
        });
        return function () {
            map_1.removeMarker(props.markerStore, props.pin);
        };
    }, []);
    return created ? ReactDOM.createPortal(props.pinRenderer(props.map, props.pin), document.getElementById(pinOverlayRef.current.getId())) : null;
};
exports.PinOverlayComponent = PinOverlayComponent;
